import { useLayoutEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function M_HeaderBox({ isLogin }: { isLogin: boolean }) {
  const navigate = useNavigate();
  const [isTiny, setIsTiny] = useState<boolean>(
    window.innerWidth < 360 ? true : false,
  );
  useLayoutEffect(() => {
    const handleResize = () => {
      setIsTiny(window.innerWidth < 360);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <header className='w-full fixed left-0 top-0 bg-white z-30'>
      <div className='w-full flex-wrap py-[14px] px-[20px] h-[64px] flex justify-between items-center gap-[10px] '>
        <div className='flex justify-start items-center gap-[30px]'>
          {isTiny ? (
            <h1
              className='w-[30px] cursor-pointer'
              onClick={() => {
                window.location.reload();
                window.scrollTo({ top: 0 });
              }}
            >
              <img
                src='/imgs/icons/symbol.webp'
                alt='한국영업경제인협회'
                className='w-full h-[30px] object-contain'
              />
            </h1>
          ) : (
            <h1
              className='w-[153px] cursor-pointer'
              onClick={() => {
                window.location.reload();
                window.scrollTo({ top: 0 });
              }}
            >
              <img
                src='/imgs/icons/logo.webp'
                alt='한국영업경제인협회'
                className='w-full h-[30px] object-contain'
              />
            </h1>
          )}
        </div>
        <div className='flex justify-start items-center gap-[8px]  ml-auto '>
          {isLogin === false ? (
            <>
              <Link
                to='https://kodeal.fks.co.kr/login'
                target='_blank'
                className='text-center text-[14px] leading-[14px] font-[500] py-[10px] h-[36px] w-[68px] px-[5px] rounded-[10px] border border-[#E5E5EC]'
              >
                로그인
              </Link>
              <Link
                to='https://kodeal.fks.co.kr/signup'
                target='_blank'
                className='text-center text-[14px] leading-[14px] font-[500] py-[10px] h-[36px] w-[68px] px-[5px] rounded-[10px] bg-[#172A88] text-white'
              >
                회원가입
              </Link>
            </>
          ) : (
            <Link
              to='https://kodeal.fks.co.kr/login'
              target='_blank'
              className='text-center text-[14px] leading-[14px] font-[500] py-[10px] h-[36px] w-[120px] px-[5px] rounded-[10px] border border-[#E5E5EC]'
            >
              코딜홈 바로가기
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
